import ApiData from "../api/ApiData";
import ApiDataAnalitic from "../api/ApiDataAnalitic";
import { getCalendarYearRange } from "./productionAuditPeriodUtils";
import {
  buildGlobalProductionCatalog,
  buildProductionSetFromCompanyApi,
  buildProductionSetFromReport,
  classifyProductionMismatch,
} from "./productionSiteAuditUtils";

export async function auditCompanyProduction({
  companyId,
  catalogRows,
  companyNames,
  year,
  signal,
}) {
  const { from, to } = getCalendarYearRange(year);
  const lkRows = await ApiData.fetchCompanyProductionList(companyId, signal);
  const P = buildProductionSetFromCompanyApi(lkRows);
  const message = await ApiDataAnalitic.fetchLabelStatisticSaYearMerged({
    companyId,
    from,
    to,
    signal,
  });
  const R = buildProductionSetFromReport(message?.production);
  const globalCatalog = buildGlobalProductionCatalog(catalogRows);
  const result = classifyProductionMismatch(
    P,
    R,
    globalCatalog,
    companyNames,
    companyId,
  );
  return { ...result, period: { from, to } };
}

export function buildCompanyNameMap(companies) {
  const map = new Map();
  if (!Array.isArray(companies)) {
    return map;
  }
  for (const c of companies) {
    const id = Number(c?.id);
    if (Number.isFinite(id)) {
      map.set(id, c.name_company ?? `ID ${id}`);
    }
  }
  return map;
}
